import { useBrand } from '@/contexts/BrandContext';
import type { LogoDisplay } from '@/config/brand';

const DEFAULT_LOGO_DISPLAY: LogoDisplay = {
  mode: 'text',
  showGlow: true,
  textStyle: { fontSize: '18px', fontWeight: '500' },
};

export default function ReactLogo() {
  const brand = useBrand();
  const display = brand.logoDisplay ?? DEFAULT_LOGO_DISPLAY;

  const handleLogoClick = () => {
    if (brand.logoClickable === false) return;
    if (!brand.isDefault) return;
    const logoUrl = brand.logoUrl ?? import.meta.env.VITE_LOGO_URL;
    if (logoUrl) {
      window.open(logoUrl, '_blank');
    }
  };

  const isClickable = brand.logoClickable !== false && brand.isDefault;

  return (
    // 顶部logo区域
    <div
      style={{
        height: '66px',
        display: 'flex',
        alignItems: 'center',
        padding: '0 24px',
        position: 'relative',
        zIndex: 2,
        cursor: isClickable ? 'pointer' : 'default',
      }}
      onClick={handleLogoClick}
    >
      <div
        style={{
          position: 'relative',
          width: display.containerWidth ?? '180px',
          height: '56px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          overflow: 'hidden',
        }}
      >
        {/* 光晕效果 — 仅在配置开启时渲染 */}
        {display.showGlow && (
          <>
            <div
              style={{
                position: 'absolute',
                width: '67px',
                height: '56px',
                background:
                  'radial-gradient(70% 60% at 25% 50%, rgba(255,140,0,0.45) 0%, rgba(255,80,0,0.2) 45%, rgba(20,20,20,0) 85%)',
                left: '0',
                top: '0',
                zIndex: 1,
                filter: 'blur(7px)',
              }}
            />
            {/* 次要光晕增强亮度 */}
            <div
              style={{
                position: 'absolute',
                width: '44px',
                height: '44px',
                background:
                  'radial-gradient(circle at center, rgba(255,170,30,0.5) 0%, rgba(255,120,20,0.1) 70%, rgba(20,20,20,0) 100%)',
                left: '12px',
                top: '6px',
                zIndex: 1,
                filter: 'blur(3px)',
              }}
            />
          </>
        )}

        {/* Logo文字内容 — 保持原始 DOM 结构 */}
        <div
          style={{
            position: 'relative',
            zIndex: 2,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '0',
            width: '100%',
          }}
        >
          <span
            style={{
              fontSize: display.textStyle?.fontSize ?? '18px',
              fontWeight: display.textStyle?.fontWeight ?? '500',
              color: 'white',
              textShadow: display.showGlow
                ? '0 0 10px rgba(255, 180, 0, 0.5)'
                : 'none',
            }}
          >
            {/* 纯图片模式：图片放在 span 内，保持与原始代码一致的渲染上下文 */}
            {display.mode === 'image' && display.image && (
              <img
                style={{
                  height: '100%',
                  width: 'auto',
                  maxWidth: '100%',
                  objectFit: 'contain',
                  verticalAlign: 'middle',
                }}
                src={display.image}
                alt=""
              />
            )}

            {/* 图标+文字模式：图片在文字前面 */}
            {display.mode === 'image-text' && display.image && (
              <img
                src={display.image}
                alt=""
                style={{
                  width: display.imageStyle?.width ?? '32px',
                  height: display.imageStyle?.height ?? '32px',
                  objectFit: 'contain',
                  verticalAlign: 'middle',
                  marginRight: '8px',
                }}
              />
            )}

            {/* 文字：text / image-text 模式显示 */}
            {display.mode !== 'image' && (display.text ?? brand.siteName)}
          </span>
        </div>
      </div>
    </div>
  );
}
